<template>
  <el-dialog
          :title="'出库'"
          :close-on-click-modal="false"
          :visible.sync="visible"
          style="text-align: left">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
             label-width="150px">

      <el-form-item label="出库日期" prop="time">
        <el-date-picker
                v-model="dataForm.time"
                type="date"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="大队" prop="recipient">
        <el-select    filterable   v-model="dataForm.recipient"  placeholder="请选择大队">
          <el-option
                  v-for="item in depts"
                  :key="item.bmid"
                  :label="item.bmmc"
                  :value="item.bmid"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="清单">
        <el-row>
          <el-select clearable  @change="getConfigDetail"   filterable   v-model="configId"  placeholder="选择配置">
            <el-option
                    v-for="item in configs"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
            </el-option>
          </el-select>
        </el-row>
       <el-row>
         <el-form :model="form" :rules="rules" ref="form" >
           <el-table :data="form.datils"  border style="width: 100%">
             <el-table-column  label="类型" >
               <template slot-scope="scope">
                 <el-form-item :prop="'datils.'+scope.$index + '.id'" :rules='rules.name'>

                   <el-select size="mini"  @change="((val)=>{changethisRow(val,scope.$index)})" v-model="scope.row.id"  placeholder="请选择">
                     <el-option
                             v-for="(item, index) in types"
                             :key="item.id"
                             :label="item.name+(setDisabled2(item, index))"
                             :disabled="setDisabled(item, scope.$index)"
                             :value="item.id">
                     </el-option>
                   </el-select>
                 </el-form-item>
               </template>

             </el-table-column>
             <el-table-column  label="规格">
               <template slot-scope="scope">
                 {{scope.row.specification}}
               </template>
             </el-table-column>
             <el-table-column  label="库存">
               <template slot-scope="scope">
                 {{scope.row.inventory}}
               </template>
             </el-table-column>
             <el-table-column label="数量">
               <template slot-scope="scope">
                 <el-form-item  :prop="'datils.'+scope.$index + '.num'" :rules='rules.num'>
                  <el-input-number style="width: 100px;" size="mini" v-model="scope.row.num" :max="scope.row.inventory" :step="1" :min="0"></el-input-number>
                 </el-form-item>
               </template>
             </el-table-column>

             <el-table-column prop="operation" fixed="right">
               <template slot="header" slot-scope="scope">
                 <el-button size="mini" @click="click_add( scope.row, scope.$index)">新增</el-button>
               </template>
               <template slot-scope="scope">


                 <!--               <el-button size="mini" @click="click_reset(scope.row, scope.$index)">重置</el-button>-->
                 <el-button size="mini" @click="click_delete(scope.row, scope.$index)">删除</el-button>



               </template>
             </el-table-column>
           </el-table>
         </el-form>
       </el-row>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {

    data () {
      const validateNumber = (rule, value, callback) => {
        var patrn = /^\d+(\.\d+)?$/;
        if(value) {
          if (!patrn.exec(value)) {
            callback(new Error('请填写数字'))
          } else {
            var index = rule.field.split('.')[1];

            if(index && this.form.datils[index].inventory < value){
              callback(new Error('库存不足'))
            }
            callback()
          }
        } else {
          callback()
        }
      }
      return {
        form: {
          datils: [

          ],
        },
        depts:[],
        //表单验证规则
        rules: {
          name: [{
            required: true,
            trigger: 'blur',
            message: '请选择装备',
          }],
          
          num: [,{validator:validateNumber,trigger: 'change'}],
          
        },

        visible: false,
        dataForm: {
          recipient:'',
          time: '',
          type: 0
        },
        configs:[],
        types: [],
        fileList:[],
        fileList2:[],
        configId:'',
        uploadUrl:'',
        dataRule: {
          recipient: [
            {required: true, message: '大队不能为空', trigger: 'blur'},
          ],
          time: [
            {required: true, message: '请选择出库日期', trigger: 'blur'},
          ],
        }
      }
    },
    computed: {
  setDisabled () {
    return function (opt, index) {
      console.log('index:',index)
      // opt为每项option，index为el-select索引
      var newArr = this.types.filter(function (obj) {
          return obj.id== opt.id;
        });
      // 全部已选择
      // let selectedArr = this.form.datils.map(item => item.value)
      let selectedArr = []
      this.form.datils.forEach(item => {
        if(item.id != undefined && item.id != ''){
          selectedArr.push(item.id)
        }
})
selectedArr = selectedArr.filter(item => item != this.form.datils[index].id)
      // 删除自己的已选
      // selectedArr.splice(index, 1)
      // 其它的已选，禁用
      // return selectedArr.includes(opt.value)
      return newArr[0].inventory == 0 || selectedArr.indexOf(opt.id) != -1?true:false
    }
  },
  setDisabled2 () {
    return function (opt, index) {
      var newArr = this.types.filter(function (obj) {
          return obj.id== opt.id;
        });
        console.log('newArr:',newArr)
      return newArr[0].inventory == 0?'(库存为0)':''
    }
  }
},
    methods: {
      init (id) {
        this.dataForm.recipient = id
        this.visible = true
        this.configId = ''
        this.$nextTick(() => {
          this.getDepts()
          this.getConfig()
          this.getTypes()
          this.$refs['dataForm'].resetFields()
          this.$refs['form'].resetFields()
          this.form.datils =  [

          ];
          this.fileList=[]
        })

      },
      changethisRow(config,index) {
    console.log(config,index)
        var newArr = this.types.filter(function (obj) {
          return obj.id== config;
        });
      var parse = JSON.parse(JSON.stringify(newArr));
      console.log('parse:',parse)
    if(parse && parse.length>0)
    this.form.datils.splice(index,1,parse[0])
      },
      getConfig() {
        let that = this;
        this.$request.get('/bjba/equip/config/getAll').then(res => {
          console.log("bmxx:", res);
          that.configs = res.data.data;
        })
      },
      getDepts() {

        this.$request.get('/bjba/kqtj/getFirstMentForUser', {
          params: {
            userid: this.$store.getters.username
          }

        }).then(res => {
          this.depts = res.data
        })
      },
      getConfigDetail() {
        this.$http({
          url: '/bjba/equip/config/details/'+this.configId,
          method: 'get'
        }).then(({data}) => {
          this.form.datils = data.data
        })
      },
      getTypes() {
        this.$request.get('/bjba/equip/type/getAll').then(res => {

          this.types = res.data.data;
        })
      },

      //新增-重置操作
      click_reset(item,index) {
        this.resetField('form',index);
      },
      //对部分表单字段进行重置
      resetField(form,index){
        console.log('indexindexindexindexindexindexindex')
        this.$refs[form].fields.forEach(item=>{
          if(item.prop.split(".")[1] === index){
            item.resetField();
          }
        })
      },
      //删除操作
      click_delete(item,index) {
        this.$confirm("确定删除该条数据吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
                .then(() => {
                  //模拟删除一条数据
                  this.form.datils.splice(index,1);
                })
                .catch(() => {});
      },
      //新增操作
      click_add(item,index) {
        // if( !this.validateField('form',index) ) return;
        //模拟新增一条数据
        var itemClone={
          id:'',
          num: ''
        }
        this.form.datils.push(itemClone);
        // this.resetField('form',index);
      },
      
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            this.$refs['form'].validate((valid2) => {
              // this.dataForm.datils =
              var data = JSON.parse(JSON.stringify(this.dataForm));
              data.details = this.form.datils.filter(function (obj) {
                return  obj.num || obj.num!=0
              });
              try{  
                this.form.datils.forEach(item=>{
          if(item.num == 0 || item.num ==undefined ||item.num ==''){
            this.$message({
                      message: item.name + '出库数量不正确!',
                      type: 'error',
                      duration: 4500
                    })
                    throw new Error('')
          }
        })
              }catch (e) {
                return
              };              
              if(valid2){
              // if(false){
                this.$http({
                  url: '/bjba/equip/out/save',
                  method: 'post',
                  data: data
                }).then(({data}) => {
                  if (data && data.code === 200) {
                    this.$message({
                      message: '操作成功',
                      type: 'success',
                      duration: 1500
                    })
                    this.visible = false
                    this.$emit('refreshDataList')
                  } else if(data && data.code === 500) {
                    this.$message({
                      message: data.message,
                      type: 'error',
                      duration: 1500
                    })
                  }
                })
              }
            })
          }
        })
      }
    }
  }
</script>
